import { createSlice } from '@reduxjs/toolkit';

import * as reducers from 'store/reducers/pdpReducer';
import { IPdp } from 'store/types/pdpTypes';

const initialState: IPdp = {
  productTemplate: null,
  factsWindowData: {
    brandProducts: [],
    silhouetteProducts: [],
    categoryProducts: [],
    isCategoryAndFacetMatching: false,
  },
  featuredInCollections: [],
  buyBarVariants: {
    allSizes: [],
    availableSizes: [],
    usedAvailableSizes: [],
    newAvailableSizes: [],
    mapSizeToVariants: {},
  },
  userWants: [],
  tempUserWantSize: null,
  isWantsWindowOpen: false,
};

export const pdpSlice = createSlice({
  name: 'pdp',
  initialState,
  reducers,
});

export const {
  clearTempUserWant,
  setBuyBarVariants,
  setProductTemplateData,
  setUserWants,
  setTempUserWant,
  setIsWantsWindowOpen,
} = pdpSlice.actions;

export default pdpSlice.reducer;
